import HomeDashP2 from "./views/sp/HomeDashP2";
import HomeDashTeamP2 from "./views/sp/HomeDashTeamP2";
import TeamMemberP2 from "./views/sp/TeamMemberP2";
import PayBenefitsP2 from "./views/sp/PayBenefitsP2";
import AnnualCompP2 from "./views/sp/AnnualCompP2";
import AbsenceP2 from "./views/sp/AbsenceP2";
import AbsenceCalendarP2 from "./views/sp/AbsenceCalendarP2";
import PerformanceP2 from "./views/sp/PerformanceP2";
import AssessmentP2 from "./views/sp/AssessmentP2";
import NavigatingP2 from "./views/sp/NavigatingP2";
import HiringP2 from "./views/sp/HiringP2";
import HiringMoreP2 from "./views/sp/HiringMoreP2";
import AnalyticsP2 from "./views/sp/AnalyticsP2";
import AnalyticsMoreP2 from "./views/sp/AnalyticsMoreP2";
import RecognitionP2 from "./views/sp/RecognitionP2";
import OrgChartP2 from "./views/sp/OrgChartP2";
import PerformanceObjectivesP2 from "./views/sp/PerformanceObjectivesP2";
import PerformanceFeedbackP2 from "./views/sp/PerformanceFeedbackP2";
import CompensationPlanningP2 from "./views/sp/CompensationPlanningP2";

export default {
  firstName: "Steve",
  lastName: "Pendleton",
  personaViews: [
    {
      image: "HomeDashP2",
      images: ["SP-Homepage-1", "SP-Homepage-2", "SP-Homepage-3"],
      title: "homeDashboard.persona2.title",
      body: "homeDashboard.persona2.body",
      hotspots: HomeDashP2,
      index: 0,
    },
    {
      image: "HomeDashTeamP2",
      images: ["SP-Homepage-Team"],
      title: "homeDashTeamP2.title",
      body: "homeDashTeamP2.body",
      hotspots: HomeDashTeamP2,
      index: 1,
    },
    {
      image: "TeamMemberP2",
      images: ["SP-Team-Member"],
      title: "teamMemberP2.title",
      body: "teamMemberP2.body",
      hotspots: TeamMemberP2,
      index: 2,
    },
    {
      image: "PayBenefitsP2",
      images: ["SP-Pay-Benefits"],
      title: "payBenefitsP2.title",
      body: "payBenefitsP2.body",
      hotspots: PayBenefitsP2,
      index: 3,
    },
    {
      image: "AnnualCompP2",
      images: ["SP-Annual-Comp-1", "SP-Annual-Comp-2", "SP-Annual-Comp-3"],
      title: "annualCompP2.title",
      body: "annualCompP2.body",
      hotspots: AnnualCompP2,
      index: 4,
    },

    // Note Unused page. Did not remove to preserve index
    {
      image: "AbsenceP2",
      images: ["SP-Absence"],
      title: "absenceP2.title",
      body: "absenceP2.body",
      hotspots: AbsenceP2,
      index: 5,
    },
    {
      image: "AbsenceCalendarP2",
      images: ["SP-Absence-Calendar"],
      title: "absenceCalendarP2.title",
      body: "absenceCalendarP2.body",
      hotspots: AbsenceCalendarP2,
      index: 6,
    },
    {
      image: "PerformanceP2",
      images: ["SP-Performance"],
      title: "performanceP2.title",
      body: "performanceP2.body",
      hotspots: PerformanceP2,
      index: 7,
    },
    {
      image: "AssessmentP2",
      images: ["SP-Assessment"],
      title: "assessmentP2.title",
      body: "assessmentP2.body",
      hotspots: AssessmentP2,
      index: 8,
    },
    {
      image: "NavigatingP2",
      images: ["SP-Homepage-Navigation"],
      title: "navigatingP2.title",
      body: "navigatingP2.body",
      hotspots: NavigatingP2,
      index: 9,
    },

    // Note Unused page. Did not remove to preserve index
    {
      image: "HiringP2",
      images: ["SP-Hiring"],
      title: "hiringP2.title",
      body: "hiringP2.body",
      hotspots: HiringP2,
      index: 10,
    },
    {
      image: "HiringMoreP2",
      images: ["SP-Hiring-Vacancies"],
      title: "hiringMoreP2.title",
      body: "hiringMoreP2.body",
      hotspots: HiringMoreP2,
      index: 11,
    },
    {
      image: "AnalyticsP2",
      images: ["SP-Analytics"],
      title: "analyticsP2.title",
      body: "analyticsP2.body",
      hotspots: AnalyticsP2,
      index: 12,
    },
    {
      image: "AnalyticsMoreP2",
      images: [
        "SP-Analytics-Chart-1",
        "SP-Analytics-Chart-2",
        "SP-Analytics-Chart-3",
      ],
      title: "analyticsMoreP2.title",
      body: "analyticsMoreP2.body",
      hotspots: AnalyticsMoreP2,
      index: 13,
    },
    {
      image: "RecognitionP2",
      images: ["SP-Recognition"],
      title: "recognitionP2.title",
      body: "recognitionP2.body",
      hotspots: RecognitionP2,
      index: 14,
    },
    {
      image: "OrgChartP2",
      images: ["SP-Org-Chart"],
      title: "orgChartP2.title",
      body: "orgChartP2.body",
      hotspots: OrgChartP2,
      index: 15,
    },
    {
      image: "PerformanceObjectivesP2",
      images: ["SP-Performance-Objectives"],
      title: "performanceObjectivesP2.title",
      body: "performanceObjectivesP2.body",
      hotspots: PerformanceObjectivesP2,
      index: 16,
    },
    {
      image: "PerformanceFeedbackP2",
      images: ["SP-Performance-Feedback"],
      title: "performanceFeedbackP2.title",
      body: "performanceFeedbackP2.body",
      hotspots: PerformanceFeedbackP2,
      index: 17,
    },
    {
      image: "CompensationPlanningP2",
      images: ["SP-Compensation-Planning"],
      title: "compensationPlanningP2.title",
      body: "compensationPlanningP2.body",
      hotspots: CompensationPlanningP2,
      index: 18,
    },
  ],
};
